"use client";

import { Link } from "@/components/common/Link";
import { Facebook, Twitter, Linkedin, Instagram } from "lucide-react";
export default function Footer() {
  return <footer className="bg-dark-background text-foreground-dark py-12 animate-fade-in-up">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {}
          <div className="flex flex-col gap-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1497483/img/lithiumcore_logo_white.png" alt="LithiumCore" className="h-7" />
            <p className="text-sm text-muted-foreground">
              &copy; {new Date().getFullYear()} LithiumCore. All rights reserved.
            </p>
            <div className="flex flex-col gap-2">
              <Link to="#" className="text-sm text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-fast)]">
                Privacy Policy
              </Link>
              <Link to="#" className="text-sm text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-fast)]">
                Terms of Service
              </Link>
              <Link to="#" className="text-sm text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-fast)]">
                Legal Disclaimers
              </Link>
            </div>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-display font-semibold">Quick Links</h3>
            <nav className="flex flex-col gap-2">
              <Link to="/HomePage" className="text-sm text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-fast)]">
                Home
              </Link>
              <Link to="/AboutWhyUsPage" className="text-sm text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-fast)]">
                About & Why Us
              </Link>
              <Link to="/ProjectsOperationsPage" className="text-sm text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-fast)]">
                Projects & Operations
              </Link>
              <Link to="/ResourcesTechnicalPage" className="text-sm text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-fast)]">
                Resources & Technical
              </Link>
              <Link to="/SustainabilityCommunityPage" className="text-sm text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-fast)]">
                Sustainability & Community
              </Link>
              <Link to="/InvestorsMediaPage" className="text-sm text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-fast)]">
                Investors & Media
              </Link>
            </nav>
          </div>

          {}
          <div className="flex flex-col gap-4">
            <h3 className="text-lg font-display font-semibold">Connect With Us</h3>
            <div className="flex gap-4">
              <Link to="https://facebook.com" className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-fast)] hover:scale-110" aria-label="Facebook" newTab>
                <Facebook className="size-6" />
              </Link>
              <Link to="https://twitter.com" className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-fast)] hover:scale-110" aria-label="Twitter" newTab>
                <Twitter className="size-6" />
              </Link>
              <Link to="https://linkedin.com" className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-fast)] hover:scale-110" aria-label="LinkedIn" newTab>
                <Linkedin className="size-6" />
              </Link>
              <Link to="https://instagram.com" className="text-foreground-dark hover:text-accent transition-all duration-[var(--duration-fast)] hover:scale-110" aria-label="Instagram" newTab>
                <Instagram className="size-6" />
              </Link>
            </div>
            <div className="flex flex-col gap-1 mt-4">
              <p className="text-sm text-foreground-dark">123 Lithium Avenue, Springfield, USA</p>
              <p className="text-sm text-foreground-dark">+1 (555) 987-6543</p>
              <Link to="mailto:investor@lithiumcore.com" className="text-sm text-foreground-dark hover:text-accent transition-colors duration-[var(--duration-fast)]">
                investor@lithiumcore.com
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}